<nav class="bread-crumbs"
     *ngIf="!isMicroText()"
     [ngClass]="breadcrumbsClasses"
     [class.desktop]="deviceService.isDesktop()"
     [class.tablet]="deviceService.isTablet()"
     [class.mobile]="deviceService.isMobile()">
  <ng-template [ngIf]="displayMode === 'breadCrumbsOnly'">
    <div class="scroll">
      <ul class="navigation-list"
          itemscope itemtype="https://schema.org/BreadcrumbList">
        <li *ngFor="let item of breadCrumbs; let i = index, let last = last; trackBy: trackByFn"
            class="navigation-item"
            itemprop="itemListElement" itemscope
            itemtype="https://schema.org/ListItem">
          <a [routerLink]="item.link"
             class="navigation-link"
             [class.active]="last"
             [attr.data-test]="'breadcrumbs_' + item.title"
             [attr.alt]="item.title"
             [title]="item.link"
             itemprop="item">
            <span itemprop="name" class="label-navigation">{{ item.title }}</span>
            <app-icon width="6" height="10" file="chevron" icon="right"></app-icon>
            <meta itemprop="position" content="{{ i + 1 }}"/>
          </a>
        </li>
      </ul>
    </div>
  </ng-template>
  <ng-template [ngIf]="displayMode === 'default' || displayMode === 'filterOnly'">
    <div class="filter-scroll">
      <ul class="filter-list" *ngIf="isFilterListVisible">
        <li *ngFor="let filter of filterList; trackBy: trackByFn" class="filter-item">
          <div class="filter" (click)="onCleanFilter(filter)">
            <span class="label-filter" [attr.data-test]="'filter_' + filter.code">
              {{ getLabelTypeFilter(filter) | customLocale }} {{ filter.title }}
            </span>
            <app-icon class="clear-icon" icon="clear-filter"></app-icon>
          </div>
        </li>
      </ul>
    </div>
  </ng-template>
</nav>
